import type { Category, CategoryId } from './types'

/** Number of events to order in a single puzzle. */
export const PUZZLE_SIZE = 6

/** Number of "Check order" attempts allowed per puzzle. */
export const MAX_ATTEMPTS = 3

/**
 * Epoch for the daily counter. Puzzle #1 is the UTC day of this date.
 * Keep this fixed once shipped — changing it reshuffles every past day.
 */
export const EPOCH_UTC = Date.UTC(2025, 0, 1) // 2025-01-01

export const CATEGORIES: Category[] = [
  { id: 'football', name: 'Football', glyph: '⚽', tile: 's-fb' },
  { id: 'nba', name: 'NBA', glyph: '🏀', tile: 's-nb' },
  { id: 'tennis', name: 'Tennis', glyph: '🎾', tile: 's-tn' },
  { id: 'f1', name: 'Formula 1', glyph: '🏎️', tile: 's-f1' },
  { id: 'mixed', name: 'Mixed', glyph: '🏆', tile: 's-mx' },
]

export const CATEGORY_BY_ID: Record<CategoryId, Category> = CATEGORIES.reduce(
  (acc, c) => {
    acc[c.id] = c
    return acc
  },
  {} as Record<CategoryId, Category>,
)

/** Maps an event id prefix ("fb", "nb", ...) to its sport, for the tile color. */
export const SPORT_BY_PREFIX: Record<string, CategoryId> = {
  fb: 'football',
  nb: 'nba',
  tn: 'tennis',
  f1: 'f1',
}
